<template lang='pug'>
//- 提醒建立病歷資料提示區塊
div(:class='$style[`cc-popbox-create-data`]')
  div(:class='$style[`cc-content-new`]')
    IconWarn(:size='70')
    span.font-medium(:class='$style[`cc-popbox-delete-info`]')!= '提醒你，您尚未建立癌症病歷資料。訂閱VIP前請完成建立，以享受完整服務。'

    div(:class='$style[`cc-content-btn-area`]')
      button(
        title='關閉'
        tabindex='0'
        aria-label='關閉'
        :class='[$style[`cc-content-btn`], $style[`cc-content-btn-cancel`]]'
        @click='handleClickToCancel') 關閉

      button(
        title='前往建立'
        tabindex='0'
        aria-label='前往建立'
        :class='[$style[`cc-content-btn`], $style[`cc-content-btn-create`]]'
        @click='handleClickRedirect') 前往建立


</template>

<script>
import { mapMutations } from 'vuex';
import IconWarn from '../../icon/Warn';

export default {
  components: {
    IconWarn,
  },

  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClickToCancel() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleClickRedirect() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });

      this.$router.push('/sideeffect/setup').catch(() => true);
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     // loginStatus: 'user/exportLoginStatus',
  //     // loginProfile: 'user/exportUserProfile',
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     authJwtToken: 'user/exportUserJwtToken',
  //   }),
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popCreatePersonalData.scss';
</style>
